import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-merge-quote-cards',
  templateUrl: './merge-quote-cards.component.html',
  styleUrls: ['./merge-quote-cards.component.scss'],
})
export class MergeQuoteCardsComponent implements OnInit {
  @Input() vsQuote: any
  public openCard = true
  @Input() active: string
  @Input() index
  @Output() updateActiveCard = new EventEmitter<string>()
  @Output() deleteCard = new EventEmitter<string>()
  constructor(private router: Router) {}
  ngOnInit(): void {}
  closeCard(event, quoteNumber) {
    this.openCard = false
    this.deleteCard.emit(this.index)
  }
  setActive() {
    this.active = this.vsQuote.quoteId
    let el = document.getElementById(this.active)
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    this.updateActiveCard.emit(this.active)
  }
  navigateToList() {
    this.router.navigate(['quote-list'])
  }
}
